module.exports = __webpack_public_path__ + "static/media/app-image-with-text.8cd046c5.png";